import instance from "./instance";
const practiceUrl = "/practice/v1/user";

export const getLifetimeStatistics = () => {
  return instance.get(
    `${practiceUrl}/user-lifetime-statistic/get-lifetime-statistics`
  );
};
